export default {"src":"/_next/static/media/chat-icon.b83e6367.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};